angular.module('impactx.manualordercreation').controller('ManualOrderCreationDialogCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    'dataGen',
    '$redirect',
    '$context',
    ManualOrderCreationDialogCtrl]);

function ManualOrderCreationDialogCtrl($scope, $mdDialog, TranslationService, dataGen, $redirect, $context)
{
    var self = this;
    $scope.wizardIndexCompany = 1;
    $scope.wizardIndexUser = 2;
    $scope.wizardIndexContract = 3;
    $scope.wizardIndex = 0;
    $scope.loading = false;
    dataGen.getData($scope, {}, "/purchaseorder/manualordercreation/dialog").then(function () {
        $scope.trns.forward = TranslationService.get('forward');
        $scope.trns.abort = TranslationService.get('abort');
        $scope.trns.back = TranslationService.get("back");
        $scope.companyEntryPoint = $scope.data.canSelectUser ? "/purchaseorder/manualordercreation/company/admin" : "/purchaseorder/manualordercreation/company/own";
        self.checkCompanyAndForward();
    });

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.back = function ()
    {
        if ($scope.wizardIndex === $scope.wizardIndexUser) {
            $scope.data.user.selected = null;
        }
        else if ($scope.wizardIndex === $scope.wizardIndexContract) {
            $scope.data.contract.selected = null;
        }
        $scope.wizardIndex--;
    };

    this.forward = function ()
    {
        if ($scope.wizardIndex === $scope.wizardIndexUser - 1 && !$scope.data.canSelectUser) {
            self.checkContractAndForward();
        }
        else if ($scope.wizardIndex === $scope.wizardIndexUser - 1) {
            self.checkUserAndForward();
        }
        else if ($scope.wizardIndex === $scope.wizardIndexContract - 1) {
            self.checkContractAndForward();
        }
        else if ($scope.wizardIndex === $scope.wizardIndexContract) {
            self.finish();
        }
    };

    this.checkCompanyAndForward = function () {
        dataGen.getData({}, {}, $scope.companyEntryPoint).then(function (data) {
            if (data.data.entries.length === 1) {
                $scope.data.company.selected = data.data.entries[0];
                self.checkUserAndForward();
            }
            else
            {
                $scope.wizardIndex = $scope.wizardIndexCompany;
            }
        });
    };

    this.checkContractAndForward = function () {
        $scope.loading = true;
        dataGen.getData({}, {orderingCompanyId: $scope.data.company.selected.id, orderingUserId: $scope.data.user.selected.id},
            "/purchaseorder/manualordercreation/contract").then(function (data) {
            $scope.loading = false;
            if (data.data.entries.length === 1) {
                $scope.data.contract.selected = data.data.entries[0];
                self.finish();
            }
            else
            {
                $scope.wizardIndex = $scope.wizardIndexContract;
            }
        });
    };

    this.checkUserAndForward = function () {
        $scope.loading = true;
        if ($scope.data.canSelectUser) {
            dataGen.getData({}, {orderingCompanyId: $scope.data.company.selected.id},
                "/purchaseorder/manualordercreation/user").then(function (data) {
                $scope.loading = false;
                if (data.data.entries.length === 1) {
                    $scope.data.user.selected = data.data.entries[0];
                    self.checkContractAndForward();
                }
                else
                {
                    $scope.wizardIndex = $scope.wizardIndexUser;
                }
            });
        }
        else {
            $scope.loading = false;
            $scope.data.user.selected = {id: $context.userId.value};
            self.checkContractAndForward();
        }
    };

    this.finish = function ()
    {
        $mdDialog.hide();
        $redirect.redirectTo(null, "/manualordercreation/" + $scope.data.company.selected.id + "/" +
            $scope.data.user.selected.id + "/" + $scope.data.contract.selected.id);
    };
}